import { marketplaceSearchQuery } from "@/lib/scan/marketplaceSearchQuery";

const GRADERS = new Set(["PSA", "SGC", "BGS", "BVG", "BCCG", "CGC", "CSG"]);

/** Fanatics sold history supports a grader facet, but not exact grade or raw condition. */
export function fanaticsSoldsSearch({
  name,
  number,
  setName,
  game,
  printing,
  graded,
  gradingCompany,
  grade,
}: {
  name: string;
  number?: string | null;
  setName?: string | null;
  game?: string | null;
  printing?: string | null;
  graded: boolean;
  gradingCompany?: string | null;
  grade?: string | null;
}) {
  const company = gradingCompany?.trim().toUpperCase();
  const grader = company === "BECKETT" ? "BGS" : company;
  if (!name.trim() || (graded && (!grader || !GRADERS.has(grader)))) return null;
  const gradingService = graded ? grader! : "ungraded";
  const query = marketplaceSearchQuery({ name, number, setName, game, printing });
  const params = new URLSearchParams({ title: query, gradingService });
  return {
    marketplace: "Fanatics" as const,
    name,
    query,
    gradingService,
    grade: graded ? grade?.trim() : undefined,
    url: `https://sales-history.fanaticscollect.com/?${params.toString()}`,
    hint: graded ? `All ${gradingService} grades` : "Ungraded · All conditions",
  };
}

export type FanaticsSoldsSearch = NonNullable<ReturnType<typeof fanaticsSoldsSearch>>;
